import { render } from "./Conclusao.vue?vue&type=template&id=6e09994a&scoped=true&ts=true"
import script from "./Conclusao.vue?vue&type=script&lang=ts"
export * from "./Conclusao.vue?vue&type=script&lang=ts"

import "./Conclusao.vue?vue&type=style&index=0&id=6e09994a&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e09994a"]])

export default __exports__